import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult, STALE_TIME } from "../common/queries";
import api from "../http-common";

export const enrollmentApi = {
	...createCrudHooks({
		baseKey: "enrollments",
		basePath: "/enrollments",
		getParams: { include: [{ association: 'course', include: ['subject'] }, { association: 'student' }, { association: 'activities', include: ['courseDetail'] }] },
		getAllParams: { include: [{ association: 'course' }, { association: 'student' }] },
	}),

	useGetUpcoming() {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["enrollments", "upcoming"],
			queryFn: () => api.get("/enrollments", { params: { where: { status: { ['in']: ['Not Started', 'In Progress'] } }, include: [{ association: 'course' }, { association: 'student' }] } }).then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
		});
	},

	useReschedule() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: ({ id, date }) => api.post(`/enrollments/${id}/_reschedule?date=${date || ''}`).then(r => processResult(qc, r)),
		});
	},

	useUnschedule() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: (id) => api.post(`/enrollments/${id}/_unschedule`).then(r => processResult(qc, r)),
		});
	},

	useSubscribe() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: (id) => api.post(`/enrollments/${id}/_subscribe`).then(r => processResult(qc, r)),
		});
	},
};
